

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> まるばつ問題CSVインポート
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="8" class="offset-md-2 text-center">
                <vue-csv-import v-model="parseCSV" :map-fields="csvFields"></vue-csv-import>
                <progress-bar v-if="loading" size="medium" :val="val" :text="per"/>

                <CButton size="lg" color="info" @click="createItems()">登録</CButton>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      title="インポート完了"
      color="secondary"
      :show.sync="confirmModal"
    >
      インポートが完了しました。問題一覧ページに戻ります


      <template #footer>
        <CButton size="sm" color="info" @click="jumpConfirm()">OK</CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { VueCsvImport } from 'vue-csv-import';
import { required } from "vuelidate/lib/validators";
import ProgressBar from 'vue-simple-progress'
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {VueCsvImport, ProgressBar},
  data() {
    return {
      record: {},
      parseCSV: null,
      loading: false,
      per: "",
      val: 10,
      confirmModal: false,
      csvFields: {
        title: '問題文',
        industry_id: '業種',
        answer: '回答',
        commentary: '解説',
        photos: '写真'
      }
    }
  },
  validations: {
    record: {
      title: {required},
      question_type: {required},
      industry_id: {required},
      commentary: {required}
    }
  },
  methods: {
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else if(label == "question_type") {
          return this.questionTypeLabel[d]
        } else if(label == "industry_id") {
          return this.industryLabel[d]
        } else {
          return d
        }
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    jumpConfirm: function() {
      this.$router.push('/questions')
    },
    createItems: function() {
      this.loading = true
      var max = this.parseCSV.length
      this.parseCSV.forEach((q, index) => {
        this.val = (index+1) / max * 100
        this.per = ((index+1) / max * 100).toString() + "%"

        if(q.photos == "") {
          q.photos = null
        }
        q.content = null
        if(q.content == "") {
          q.content = null
        }
        q.question_type = "true_or_false"
        if(q.question_type == "true_or_false") {
          if(q.answer == "TRUE" || q.answer == "True" || q.answer == "true") {
            q.answer = "TRUE"
          }
          if(q.answer == "FALSE" || q.answer == "False" || q.answer == "false") {
            q.answer = "FALSE"
          }
        }
        console.log(q)
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/questions", {"question": q}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then((res) => {
            console.log(res)
            this.confirmModal = true
          }).catch(error => {
            console.log(error)
          })
      })
    },
  },
  mounted() {
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>

<style scoped lang="scss">
/deep/ .vue-csv-uploader-part-one {
  text-align: center;

  .form-group {
    padding: 10px 0px;
  }
}

</style>

